import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import MetalStonePage from '~/pages/metals-stones/[uid]'

import getMetalStonePageStaticPropsFunction from '~/data/metal-stone-page-data'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

export default MetalStonePage

export const getStaticProps = getMetalStonePageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: true,
  type: STORYBLOK_TYPES.METAL_STONE_PAGE,
  maxPathsInProduction: 10,
})
